import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_SUBMIT_AEIS_ADDITIONAL_DETAILS } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface SubmitAEISAdditionalDetailsRequest {
  intendedResidentialArea: string;
  workPassType: string;
  finPassport: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSubmitAEISAdditionalDetails = ({ uuid, onSuccess, onError }: Input) => {
  const postSubmitAEISAdditionalDetails = async (reqBody: SubmitAEISAdditionalDetailsRequest) => {
    await axiosClient.post(POST_SUBMIT_AEIS_ADDITIONAL_DETAILS(uuid), reqBody);
  };

  return useCustomMutation(postSubmitAEISAdditionalDetails, {
    onSuccess,
    onError,
  });
};
